import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest, call } from "redux-saga/effects";
import { getUserByToken, getFirebaseToken } from "./authCrud";
import { firebaseAuth } from '../../../../firebase';
import { signOut } from 'firebase/auth';

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  UpdateTokenRequested: "[Request Update Token] Action",
  TokenUpdated: "[Token Received] Action"
};

const initialAuthState = {
  user: undefined,
  authToken: undefined
};

export const reducer = persistReducer(
  { storage, key: "flit-auth", whitelist: ["user", "authToken"] },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Login: {
        return { ...state, user: undefined };
      }

      case actionTypes.Logout: {
        signOut(firebaseAuth);
        localStorage.removeItem('jwt');
        localStorage.removeItem('firebaseToken');
        return initialAuthState;
      }

      case actionTypes.UserLoaded: {
        const { user } = action.payload;
        return { ...state, user };
      }

      case actionTypes.TokenUpdated: {
        return { ...state, authToken: action.payload };
      }

      default:
        return state;
    }
  }
);

export const actions = {
  login: () => ({ type: actionTypes.Login }),
  register: () => ({ type: actionTypes.Register }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: user => ({ type: actionTypes.UserRequested, payload: { user } }),
  fulfillUser: user => ({ type: actionTypes.UserLoaded, payload: { user } }),
  updateToken: () => ({ type: actionTypes.UpdateTokenRequested }),
  tokenUpdated: (token) => ({ type: actionTypes.TokenUpdated, payload: token })
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    try {
      const { data: user } = yield call(getUserByToken);
      yield put(actions.fulfillUser(user));
    } catch (error) {
      console.error('❌ Failed to fetch user:', error);
      // If user fetch fails, logout
      if (error.response?.status === 401) {
        yield put(actions.logout());
      }
    }
  });

  yield takeLatest(actionTypes.UpdateTokenRequested, function* updateToken() {
    try {
      const token = yield call(getFirebaseToken);
      yield put(actions.tokenUpdated(token));
    } catch (error) {
      console.error('❌ Failed to update token:', error);
    }
  });
}